(function($) {
	$('#scroll-down').click(function() {
		window.scrollTo({
			top: window.innerHeight - $('.navbar').outerHeight(),
			behavior: "smooth"
		});
	});
})(jQuery);
